module.exports = __webpack_public_path__ + "img/ic-pw-active.267cfa91.svg";